<template>
  <div class="reg-root">
    <div class="reg-bg" :style="bgStyle"></div>
    <div class="reg-overlay"></div>

    <!-- LADO ESQUERDO -->
    <div class="reg-left">
      <div class="reg-logo-text">Abitué</div>
      <transition name="fade" mode="out-in">
        <div class="reg-left-content" :key="leftInfo.key">
          <template v-if="leftInfo.stat">
            <span class="reg-stat">{{ leftInfo.stat }}</span>
            <h1 class="reg-left-title" v-html="leftInfo.title"></h1>
          </template>
          <h1 v-else class="reg-left-title" v-html="leftInfo.title"></h1>
          <p v-if="leftInfo.sub" class="reg-left-sub">{{ leftInfo.sub }}</p>
        </div>
      </transition>
      <div v-if="fase === 'registo'" class="reg-dots">
        <span
          v-for="i in 3"
          :key="i"
          class="reg-dot"
          :class="{ active: stepR === i }"
        ></span>
      </div>
    </div>

    <!-- LADO DIREITO -->
    <div class="reg-right">
      <!-- LADO DIREITO — STEPPER -->
      <div v-if="fase === 'onboarding'" class="reg-stepper-col">
        <reg-stepper :steps="stepsOnboarding" :current="stepO" />
      </div>

      <transition name="slide" mode="out-in">
        <!-- ── REGISTO ── -->
        <reg-step1
          v-if="fase === 'registo' && stepR === 1"
          key="r1"
          :form="form"
          @done="onStep1Done"
        />

        <reg-step2
          v-else-if="fase === 'registo' && stepR === 2"
          key="r2"
          :email="form.email"
          @done="stepR = 3"
          @back="stepR = 1"
        />

        <reg-step3
          v-else-if="fase === 'registo' && stepR === 3"
          key="r3"
          @done="iniciarOnboarding"
        />

        <!-- ── ONBOARDING ── -->
        <o-step0
          v-else-if="fase === 'onboarding' && stepO === 0"
          key="o0"
          :value="pos"
          @done="onPosSelected"
        />

        <o-step1
          v-else-if="fase === 'onboarding' && stepO === 1"
          key="o1"
          :planos="planos"
          :loading="loadingPlanos"
          :value="onboarding.plano_id"
          @done="
            (v) => {
              onboarding.plano_id = v;
              stepO = 2;
            }
          "
        />

        <o-step2
          v-else-if="fase === 'onboarding' && stepO === 2"
          key="o2"
          :opcoes="addonCartoes"
          :value="onboarding.addon_cartoes_id"
          @done="
            (v) => {
              onboarding.addon_cartoes_id = v;
              stepO = 3;
            }
          "
        />

        <o-step3
          v-else-if="fase === 'onboarding' && stepO === 3"
          key="o3"
          :opcoes="addonNotificacoes"
          :notif-incluidas="notifIncluidas"
          :preco-notif-extra="precoNotifExtra"
          :value="onboarding.addon_notificacoes_id"
          @done="
            (v) => {
              onboarding.addon_notificacoes_id = v;
              stepO = 4;
            }
          "
        />

        <o-step4
          v-else-if="fase === 'onboarding' && stepO === 4"
          key="o4"
          :avenca="addonAvenca"
          @done="
            (v) => {
              onboarding.addon_avenca = v;
              stepO = 5;
            }
          "
        />

        <o-step5
          v-else-if="fase === 'onboarding' && stepO === 5"
          key="o5"
          :resumo="resumo"
          :preco-total="precoTotal"
          :loading="loadingOnboarding"
          @done="confirmarOnboarding"
        />

        <o-step6
          v-else-if="fase === 'onboarding' && stepO === 6"
          key="o6"
          @done="stepO = 7"
        />

        <o-step7
          v-else-if="fase === 'onboarding' && stepO === 7"
          key="o7"
          @done="irParaDashboard"
        />
      </transition>
    </div>
  </div>
</template>

<script>
  import RegStepper from "./components/RegStepper.vue";
  import RegStep1 from "./steps/RegStep1.vue";
  import RegStep2 from "./steps/RegStep2.vue";
  import RegStep3 from "./steps/RegStep3.vue";
  import OStep0 from "./onboarding/OStep0.vue";
  import OStep1 from "./onboarding/OStep1.vue";
  import OStep2 from "./onboarding/OStep2.vue";
  import OStep3 from "./onboarding/OStep3.vue";
  import OStep4 from "./onboarding/OStep4.vue";
  import OStep5 from "./onboarding/OStep5.vue";
  import OStep6 from "./onboarding/OStep6.vue";
  import OStep7 from "./onboarding/OStep7.vue";
  import { registerService } from "../../../services/register.service";

  // Backgrounds por passo — usa os mesmos assets do login por agora
  const BG = require("@/assets/img/auth/login-bg.png");

  const LEFT_INFO = {
    r1: {
      key: "r1",
      title: "O futuro do seu restaurante começa aqui",
      sub: "Compreenda comportamentos, crie campanhas, controle gastos e faça cross sell entre os seus restaurantes num só sítio.",
    },
    r2: {
      key: "r2",
      stat: "46%",
      title: "dos clientes gastaram mais na 2ª visita?",
    },
    r3: {
      key: "r3",
      title: "O futuro do seu restaurante começa aqui",
      sub: "Compreenda comportamentos, crie campanhas, controle gastos e faça cross sell entre os seus restaurantes num só sítio.",
    },
    o1: {
      key: "o1",
      title: "Comece por selecionar o plano standard",
      sub: "O plano standard oferece tudo o que precisa para começar a crescer.",
    },
    o2: {
      key: "o2",
      title: "O seu negócio tem um grande volume de clientes?",
      sub: "Selecione um add-on para aumentar o plafond de cartões que pode criar para o seu negócio.",
    },
    o3: {
      key: "o3",
      title: "Mais notificações, mais impacto",
      sub: "Adiciona um pack de notificações extra para comunicar ainda mais com os seus clientes.",
    },
    o4: {
      key: "o4",
      title: "Tenha tempo para se focar no que mais importa",
      sub: "Contrate uma equipa dedicada.",
    },
    o5: { key: "o5", title: "Está quase a aumentar as suas vendas", sub: "" },
    o6: { key: "o6", title: "Está quase a aumentar as suas vendas", sub: "" },
    o7: { key: "o7", title: "Já pode começar a sua nova experiência", sub: "" },
  };

  export default {
    name: "Register",
    components: {
      RegStepper,
      RegStep1,
      RegStep2,
      RegStep3,
      OStep0,
      OStep1,
      OStep2,
      OStep3,
      OStep4,
      OStep5,
      OStep6,
      OStep7,
    },

    data() {
      return {
        fase: "registo",
        stepR: 1,
        stepO: 1,

        form: { nome: "", email: "", password: "" },

        pos: null,
        onboarding: {
          plano_id: null,
          addon_cartoes_id: null,
          addon_notificacoes_id: null,
          addon_avenca: false,
        },

        // Da BD
        planos: [],
        addonCartoes: [],
        addonNotificacoes: [],
        addonAvenca: null,
        precoNotifExtra: 0.05,
        loadingPlanos: false,
        loadingOnboarding: false,

        stepsOnboarding: [
          { num: 1, name: "Plano" },
          { num: 2, name: "Addons" },
          { num: 3, name: "Notificações" },
          { num: 4, name: "Avença" },
          { num: 5, name: "Pagamento" },
          { num: 6, name: "Finalizar" },
        ],
      };
    },

    computed: {
      bgStyle() {
        return { backgroundImage: `url(${BG})` };
      },

      leftInfo() {
        if (this.fase === "registo") return LEFT_INFO[`r${this.stepR}`];
        return LEFT_INFO[`o${this.stepO}`] || LEFT_INFO.o1;
      },

      planoSelecionado() {
        return (
          this.planos.find((p) => p.id === this.onboarding.plano_id) || null
        );
      },
      addonCartoesSel() {
        return (
          this.addonCartoes.find(
            (a) => a.id === this.onboarding.addon_cartoes_id,
          ) || null
        );
      },
      addonNotifSel() {
        return (
          this.addonNotificacoes.find(
            (a) => a.id === this.onboarding.addon_notificacoes_id,
          ) || null
        );
      },

      notifIncluidas() {
        const base = this.planoSelecionado?.cartoes_incluidos || 0;
        const extra = this.addonCartoesSel?.notificacoes_incluidas || 0;
        return base + extra;
      },

      precoTotal() {
        let total = parseFloat(this.planoSelecionado?.preco_mensal || 0);
        if (this.addonCartoesSel)
          total += parseFloat(this.addonCartoesSel.preco_mensal || 0);
        if (this.addonNotifSel)
          total += parseFloat(this.addonNotifSel.preco_calculado_valor || 0);
        if (this.onboarding.addon_avenca && this.addonAvenca)
          total += parseFloat(this.addonAvenca.preco_mensal || 0);
        return Math.round(total * 100) / 100;
      },

      resumo() {
        return {
          plano: this.planoSelecionado?.nome || "—",
          addon_cartoes: this.addonCartoesSel?.label || null,
          addon_notificacoes: this.addonNotifSel?.label || null,
          avenca: this.onboarding.addon_avenca,
        };
      },
    },

    methods: {
      onPosSelected(v) {
        this.pos = v;
        localStorage.setItem("abitue_pos", v);
        this.stepO = 1;
      },

      onStep1Done(dados) {
        this.form = { ...this.form, ...dados };
        this.stepR = 2;
      },

      async iniciarOnboarding() {
        this.fase = "onboarding";
        this.stepO = 0;
        await this.carregarPlanos();
      },

      async carregarPlanos() {
        this.loadingPlanos = true;
        try {
          const data = await registerService.getPlanos();
          this.planos = data.planos || [];
          this.addonCartoes = data.addon_cartoes || [];
          this.addonNotificacoes = data.addon_notificacoes || [];
          this.addonAvenca = data.addon_avenca || null;
          this.precoNotifExtra = data.preco_notif_extra || 0.05;
          if (this.planos.length) this.onboarding.plano_id = this.planos[0].id;
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "Não foi possível carregar os planos.",
          });
        } finally {
          this.loadingPlanos = false;
        }
      },

      async confirmarOnboarding() {
        this.loadingOnboarding = true;
        try {
          const data = await registerService.guardarOnboarding({
            email: this.form.email,
            plano_id: this.onboarding.plano_id,
            addon_cartoes_id: this.onboarding.addon_cartoes_id,
            addon_notificacoes_id: this.onboarding.addon_notificacoes_id,
            addon_avenca: this.onboarding.addon_avenca,
          });

          if (data.token) {
            localStorage.setItem("tokenAbitue", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));
          }

          // Guardar pos escolhido no localStorage para o Setup usar
          if (this.pos) localStorage.setItem("abitue_pos", this.pos);
          this.$router.push("/setup");
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: err.response?.data?.error || "Erro ao concluir.",
          });
        } finally {
          this.loadingOnboarding = false;
        }
      },

      irParaDashboard() {
        this.$router.push("/dashboard");
      },
    },
  };
</script>

<style scoped lang="scss">
  /* ── ROOT ──────────────────────────────────────────────────────── */
  .reg-root {
    position: relative;
    display: flex;
    min-height: 100vh;
    width: 100%;
    overflow: hidden;
    font-family: "DM Sans", "Outfit", system-ui, sans-serif;
  }

  .reg-bg {
    position: fixed;
    inset: 0;
    background-size: cover;
    background-position: center;
    z-index: 0;
    transition: background-image 0.6s ease;
    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        135deg,
        rgba(15, 10, 8, 0.72) 0%,
        rgba(26, 18, 16, 0.55) 100%
      );
    }
  }
  .reg-overlay {
    position: fixed;
    inset: 0;
    backdrop-filter: blur(1px);
    z-index: 1;
  }

  /* ── LADO ESQUERDO ─────────────────────────────────────────────── */
  .reg-left {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 48px 8%;
    color: #fff;
  }
  .reg-logo {
    height: 28px;
    width: auto;
    filter: brightness(0) invert(1);
  }
  .reg-logo-text {
    font-size: 26px;
    font-weight: 800;
    color: #fff;
    letter-spacing: -0.5px;
  }
  .reg-left-content {
    max-width: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .reg-stat {
    font-size: 64px;
    font-weight: 900;
    color: #ff825d;
    line-height: 1;
    display: block;
    margin-bottom: 0;
    text-shadow: 0 0 40px rgba(255, 130, 93, 0.4);
  }
  .reg-left-title {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.25;
    margin-bottom: 16px;
    color: #fff;
    letter-spacing: -0.3px;
  }
  .reg-left-sub {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.65);
    margin: 0;
    line-height: 1.65;
  }
  .reg-dots {
    display: flex;
    gap: 8px;
  }
  .reg-dot {
    width: 24px;
    height: 3px;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 2px;
    transition: all 0.35s ease;
    &.active {
      background: #ff825d;
      width: 36px;
    }
  }

  /* ── LADO DIREITO (card centrado) ──────────────────────────────── */
  .reg-right {
    position: relative;
    z-index: 2;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 28px;
  }

  /* ── STEPPER COLUNA DIREITA ────────────────────────────────────── */
  .reg-stepper-col {
    position: relative;
    z-index: 2;
    width: 160px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 24px 32px 0;
  }

  /* ── STEPPER ───────────────────────────────────────────────────── */
  .reg-stepper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-self: flex-end;
    margin-bottom: 4px;
  }
  .reg-stepper-item {
    display: flex;
    align-items: center;
    gap: 10px;
    opacity: 0.38;
    transition: opacity 0.25s;
    &.active,
    &.done {
      opacity: 1;
    }
  }
  .reg-stepper-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #fff;
    transition: all 0.2s;
    .reg-stepper-item.active & {
      border-color: #ff825d;
      background: #ff825d;
    }
    .reg-stepper-item.done & {
      border-color: #ff825d;
      background: #ff825d;
    }
  }
  .reg-stepper-label {
    display: flex;
    flex-direction: column;
  }
  .reg-stepper-num {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 500;
  }
  .reg-stepper-name {
    font-size: 12.5px;
    font-weight: 600;
    color: #fff;
  }

  /* ── TRANSIÇÕES ────────────────────────────────────────────────── */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .slide-enter-active {
    transition: all 0.24s cubic-bezier(0.22, 0.68, 0, 1.2);
  }
  .slide-leave-active {
    transition: all 0.18s ease;
  }
  .slide-enter {
    opacity: 0;
    transform: translateX(24px) scale(0.98);
  }
  .slide-leave-to {
    opacity: 0;
    transform: translateX(-16px) scale(0.98);
  }

  /* ── OCULTAR NAVBAR ────────────────────────────────────────────── */
  :deep(.navbar) {
    display: none !important;
  }

  @media (max-width: 960px) {
    .reg-left,
    .reg-stepper-col {
      display: none;
    }
    .reg-right {
      padding: 24px 16px;
    }
  }
</style>
